export const CARD_COUNT = 24;

export const API_URL = `https://dog.ceo/api/breeds/image/random/${CARD_COUNT / 2}`;
